var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vx-card",
    {
      attrs: {
        title: _vm.$t("shippingDetail.shippingDetail"),
        id: "shipping-detail"
      }
    },
    [
      _c("template", { slot: "actions" }, [
        _c(
          "div",
          { staticClass: "vx-row" },
          [
            _vm.selectedOrderData && _vm.selectedOrderData.external_tracking_url
              ? _c("vs-button", {
                  staticClass: "mr-2",
                  attrs: {
                    size: "small",
                    title: "External Tracking Page",
                    alt: "External Tracking Page",
                    type: "gradient",
                    "icon-pack": "feather",
                    icon: "icon-package",
                    color: "secondary"
                  },
                  on: {
                    click: function($event) {
                      return _vm.goToExternalTracking()
                    }
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _c("vs-button", {
              staticClass: "mr-2",
              attrs: {
                size: "small",
                title: "Tracking Page",
                alt: "Tracking Page",
                type: "gradient",
                "icon-pack": "feather",
                icon: "icon-package",
                color: "primary"
              },
              on: {
                click: function($event) {
                  return _vm.goToTracking()
                }
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { attrs: { id: "shipping-detail__body" } }, [
        !_vm.selectedOrderData
          ? _c(
              "div",
              { staticClass: "text-center align-items-center justify-center" },
              [
                _c("img", {
                  staticClass: "rounded-lg mb-6",
                  staticStyle: { display: "inline" },
                  attrs: {
                    src: "/images/ilust/graphic-6.png",
                    alt: "content-img"
                  }
                }),
                _vm._v(" "),
                _c("p", [_vm._v(_vm._s(_vm.$t("shippingDetail.clickOrder")))])
              ]
            )
          : _c(
              "div",
              [
                _c("div", { staticClass: "vx-row" }, [
                  _vm.selectedOrderData.is_rating_customer
                    ? _c(
                        "div",
                        { staticClass: "vx-col w-full mb-3" },
                        [
                          _c(
                            "vs-alert",
                            { attrs: { color: "success" } },
                            [
                              _c("div", { staticClass: "text-center mb-4" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("shippingDetail.thankYouRating")
                                  ) + "!"
                                )
                              ]),
                              _vm._v(" "),
                              _c("star-rating", {
                                attrs: {
                                  "show-rating": false,
                                  "read-only": true,
                                  "star-size": 30,
                                  rating: parseInt(
                                    _vm.selectedOrderData.is_rating_customer
                                      .rating
                                  )
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.selectedOrderData.can_rate
                    ? _c(
                        "div",
                        { staticClass: "vx-col w-full mb-3 text-center" },
                        [
                          _c(
                            "vs-button",
                            {
                              attrs: {
                                size: "small",
                                title: "Review order",
                                alt: "Review order",
                                type: "gradient",
                                "icon-pack": "feather",
                                icon: "icon-star",
                                color: "warning"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.openRatingDialog()
                                }
                              }
                            },
                            [
                              _c("span", { staticClass: "text-capitalize" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("shippingDetail.rateOrder"))
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "vx-col w-full" },
                    [
                      _c("small", { staticClass: "activity-desc" }, [
                        _vm._v(_vm._s(_vm.$t("attribute.orderNumber")) + " ")
                      ]),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c("p", { staticClass: "text-xl font-bold mb-3" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.selectedOrderData.unique_id) +
                            "\n            "
                        ),
                        _vm.selectedOrderData.customer_ref_id
                          ? _c("span", [
                              _vm._v(
                                "- " +
                                  _vm._s(_vm.selectedOrderData.customer_ref_id)
                              )
                            ])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c(
                        "vs-button",
                        {
                          attrs: {
                            size: "small",
                            type: "gradient",
                            color: "success"
                          },
                          on: {
                            click: function($event) {
                              return _vm.printReceipt()
                            }
                          }
                        },
                        [
                          _c("span", { staticClass: "text-capitalize" }, [
                            _vm._v(_vm._s(_vm.$t("attribute.receipt")))
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      !_vm.awbBase64
                        ? _c(
                            "vs-button",
                            {
                              attrs: {
                                size: "small",
                                type: "gradient",
                                color: "primary"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.printWaybill()
                                }
                              }
                            },
                            [
                              _c("span", { staticClass: "text-capitalize" }, [
                                _vm._v(_vm._s(_vm.$t("attribute.waybill")))
                              ])
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.awbBase64
                        ? _c(
                            "vs-button",
                            {
                              attrs: {
                                size: "small",
                                type: "gradient",
                                color: "primary"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.printAirWaybill()
                                }
                              }
                            },
                            [
                              _c("span", { staticClass: "text-capitalize" }, [
                                _vm._v(_vm._s(_vm.$t("attribute.airWaybill")))
                              ])
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.invoiceBase64
                        ? _c(
                            "vs-button",
                            {
                              attrs: {
                                size: "small",
                                type: "gradient",
                                color: "primary"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.printInvoice()
                                }
                              }
                            },
                            [
                              _c("span", { staticClass: "text-capitalize" }, [
                                _vm._v(_vm._s(_vm.$t("attribute.invoice")))
                              ])
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.selectedOrderData.status == "ORDERED" ||
                      _vm.selectedOrderData.status == "ACKNOWLEDGED" ||
                      _vm.selectedOrderData.status == "ACCEPTED" ||
                      _vm.selectedOrderData.status == "FAILED COLLECTION"
                        ? _c(
                            "vs-button",
                            {
                              attrs: { size: "small", color: "warning" },
                              on: {
                                click: function($event) {
                                  return _vm.cancelOrder()
                                }
                              }
                            },
                            [
                              _c("span", { staticClass: "text-capitalize" }, [
                                _vm._v(_vm._s(_vm.$t("action.cancel")))
                              ])
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showEnrouteButton
                        ? _c(
                            "vs-button",
                            {
                              attrs: { size: "small", color: "success" },
                              on: {
                                click: function($event) {
                                  _vm.enrouteOrderDialogVisibility = true
                                }
                              }
                            },
                            [
                              _c("span", { staticClass: "text-capitalize" }, [
                                _vm._v(_vm._s(_vm.$t("action.enroute")))
                              ])
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("vs-divider"),
                _vm._v(" "),
                _c("small", { staticClass: "activity-desc" }, [
                  _vm._v(_vm._s(_vm.$t("attribute.payment")) + " ")
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "font-bold" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.renderCurrency(
                          _vm.selectedOrderData.total_price,
                          _vm.selectedOrderData.currency
                        )
                      ) +
                      " |\n        " +
                      _vm._s(_vm.selectedOrderData.payment_method) +
                      "\n      "
                  )
                ]),
                _vm._v(" "),
                _c("vs-divider"),
                _vm._v(" "),
                _c("div", [
                  _c("div", { staticClass: "vx-row" }, [
                    _c("div", { staticClass: "vx-col w-full lg:w-1/2 mb-3" }, [
                      _vm.selectedOrderData.delivery_type ==
                      _vm.deliveryTypeEnum.SAME_DAY_DELIVERY
                        ? _c("small", { staticClass: "activity-desc" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("shippingDetail.pickupAfter")) +
                                "\n            "
                            )
                          ])
                        : _vm.selectedOrderData.delivery_type ==
                          _vm.deliveryTypeEnum.ON_DEMAND_DELIVERY
                        ? _c("small", { staticClass: "activity-desc" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("shippingDetail.pickupAt")) +
                                "\n            "
                            )
                          ])
                        : _vm.selectedOrderData.delivery_type ==
                          _vm.deliveryTypeEnum.ONE_TO_THREE_DAYS_DELIVERY
                        ? _c("small", { staticClass: "activity-desc" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.$t("shippingDetail.estimatedPickupBefore")
                                ) +
                                "\n            "
                            )
                          ])
                        : _c("small", { staticClass: "activity-desc" }, [
                            _vm._v(
                              _vm._s(_vm.$t("shippingDetail.pickupBefore"))
                            )
                          ]),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _vm.selectedOrderData.delivery_type !==
                      _vm.deliveryTypeEnum.ONE_TO_THREE_DAYS_DELIVERY
                        ? _c("p", { staticClass: "font-bold" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.renderToHumanDate(
                                    _vm.selectedOrderData.booking_date
                                  )
                                ) +
                                "\n            "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.selectedOrderData.delivery_type ==
                      _vm.deliveryTypeEnum.ONE_TO_THREE_DAYS_DELIVERY
                        ? _c("p", { staticClass: "font-bold" }, [
                            _vm.checkIfSameMonthYear(
                              _vm.selectedOrderData.booking_date,
                              _vm.selectedOrderData.req_pickup_date,
                              "YYYY-MM-DDTHH:mm:ss",
                              "YYYY-MM-DDTHH:mm:ss"
                            )
                              ? _c("span", [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.renderMoment(
                                          _vm.selectedOrderData.booking_date,
                                          "YYYY-MM-DDTHH:mm:ss",
                                          "DD"
                                        )
                                      ) +
                                      " -\n                " +
                                      _vm._s(
                                        _vm.renderMoment(
                                          _vm.selectedOrderData.req_pickup_date,
                                          "YYYY-MM-DDTHH:mm:ss",
                                          "DD"
                                        )
                                      ) +
                                      " \n                " +
                                      _vm._s(
                                        _vm.renderMoment(
                                          _vm.selectedOrderData.booking_date,
                                          "YYYY-MM-DDTHH:mm:ss",
                                          "MMM YYYY"
                                        )
                                      ) +
                                      ",\n              "
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.checkIfSameMonthYear(
                              _vm.selectedOrderData.booking_date,
                              _vm.selectedOrderData.req_pickup_date,
                              "YYYY-MM-DDTHH:mm:ss",
                              "YYYY-MM-DDTHH:mm:ss"
                            )
                              ? _c("span", [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.renderMoment(
                                          _vm.selectedOrderData.booking_date,
                                          "YYYY-MM-DDTHH:mm:ss",
                                          "DD MMM YYYY"
                                        )
                                      ) +
                                      "\n                -\n                " +
                                      _vm._s(
                                        _vm.renderMoment(
                                          _vm.selectedOrderData.req_pickup_date,
                                          "YYYY-MM-DDTHH:mm:ss",
                                          "DD MMM YYYY"
                                        )
                                      ) +
                                      "\n              "
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.renderMoment(
                                    _vm.selectedOrderData.booking_date,
                                    "YYYY-MM-DDTHH:mm:ss",
                                    "HH:mm"
                                  )
                                ) +
                                "\n            "
                            )
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "vx-col w-full lg:w-1/2 mb-3" }, [
                      _vm.selectedOrderData.delivery_type !==
                      _vm.deliveryTypeEnum.ON_DEMAND_DELIVERY
                        ? _c("small", { staticClass: "activity-desc" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.$t(
                                    "shippingDetail.estimatedDeliveryBefore"
                                  )
                                ) +
                                "\n            "
                            )
                          ])
                        : _c("small", { staticClass: "activity-desc" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("shippingDetail.estimatedDeliveryAt")
                              )
                            )
                          ]),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _vm.selectedOrderData.delivery_date &&
                      _vm.selectedOrderData.delivery_type !==
                        _vm.deliveryTypeEnum.ONE_TO_THREE_DAYS_DELIVERY
                        ? _c("p", { staticClass: "font-bold" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.renderToHumanDate(
                                    _vm.selectedOrderData.delivery_date
                                  )
                                ) +
                                "\n            "
                            )
                          ])
                        : _vm.selectedOrderData.delivery_type ==
                          _vm.deliveryTypeEnum.ONE_TO_THREE_DAYS_DELIVERY
                        ? _c("p", { staticClass: "font-bold" }, [
                            _vm.checkIfSameMonthYear(
                              _vm.selectedOrderData.req_pickup_date,
                              _vm.selectedOrderData.delivery_date,
                              "YYYY-MM-DDTHH:mm:ss",
                              "YYYY-MM-DDTHH:mm:ss"
                            )
                              ? _c("span", [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.renderMoment(
                                          _vm.selectedOrderData.req_pickup_date,
                                          "YYYY-MM-DDTHH:mm:ss",
                                          "DD"
                                        )
                                      ) +
                                      " -\n                " +
                                      _vm._s(
                                        _vm.renderMoment(
                                          _vm.selectedOrderData.delivery_date,
                                          "YYYY-MM-DDTHH:mm:ss",
                                          "DD"
                                        )
                                      ) +
                                      " \n                " +
                                      _vm._s(
                                        _vm.renderMoment(
                                          _vm.selectedOrderData.req_pickup_date,
                                          "YYYY-MM-DDTHH:mm:ss",
                                          "MMM YYYY"
                                        )
                                      ) +
                                      ",\n              "
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.checkIfSameMonthYear(
                              _vm.selectedOrderData.req_pickup_date,
                              _vm.selectedOrderData.delivery_date,
                              "YYYY-MM-DDTHH:mm:ss",
                              "YYYY-MM-DDTHH:mm:ss"
                            )
                              ? _c("span", [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.renderMoment(
                                          _vm.selectedOrderData.req_pickup_date,
                                          "YYYY-MM-DDTHH:mm:ss",
                                          "DD MMM YYYY"
                                        )
                                      ) +
                                      "\n                -\n                " +
                                      _vm._s(
                                        _vm.renderMoment(
                                          _vm.selectedOrderData.delivery_date,
                                          "YYYY-MM-DDTHH:mm:ss",
                                          "DD MMM YYYY"
                                        )
                                      ) +
                                      "\n              "
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.renderMoment(
                                    _vm.selectedOrderData.req_pickup_date,
                                    "YYYY-MM-DDTHH:mm:ss",
                                    "HH:mm"
                                  )
                                ) +
                                "\n            "
                            )
                          ])
                        : _c("p", [
                            _c("i", [
                              _vm._v(
                                "--- " +
                                  _vm._s(
                                    _vm.$t("shippingDetail.notAvailable")
                                  ) +
                                  " ---"
                              )
                            ])
                          ])
                    ])
                  ]),
                  _vm._v(" "),
                  _vm.selectedOrderData.can_reschedule
                    ? _c(
                        "div",
                        [
                          _c(
                            "vs-button",
                            {
                              staticClass: "mb-3",
                              attrs: {
                                size: "small",
                                type: "gradient",
                                color: "primary"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.reschedule()
                                }
                              }
                            },
                            [
                              _c("span", { staticClass: "text-capitalize" }, [
                                _vm._v(_vm._s(_vm.$t("action.reschedule")))
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c("br")
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("small", [
                    _c(
                      "i",
                      [
                        _c(
                          "i18n",
                          {
                            attrs: {
                              path: "shippingDetail.contactQuery",
                              tag: "label"
                            }
                          },
                          [
                            _c("strong", [
                              _vm._v("*" + _vm._s(_vm.$t("attribute.liveChat")))
                            ])
                          ]
                        )
                      ],
                      1
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("vs-divider"),
                _vm._v(" "),
                _vm.selectedOrderData.req_pickup_date &&
                _vm.selectedOrderData.delivery_type !==
                  _vm.deliveryTypeEnum.ONE_TO_THREE_DAYS_DELIVERY
                  ? _c(
                      "div",
                      [
                        _c("div", { staticClass: "vx-row" }, [
                          _c("div", { staticClass: "vx-col" }, [
                            _c("small", { staticClass: "activity-desc" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "shippingDetail.requestCollectionBefore"
                                  )
                                ) + " "
                              )
                            ]),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            _c("p", { staticClass: "font-bold" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.renderToHumanDate(
                                    _vm.selectedOrderData.req_pickup_date
                                  )
                                )
                              )
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("vs-divider")
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.selectedOrderData.driver
                  ? _c(
                      "div",
                      [
                        _c("small", { staticClass: "activity-desc" }, [
                          _vm._v(_vm._s(_vm.$t("shippingDetail.driverDetail")))
                        ]),
                        _vm._v(" "),
                        _vm.selectedOrderData.driver.name
                          ? _c("div", [
                              _vm.selectedOrderData.delivery_type ==
                              _vm.deliveryTypeEnum.SAME_DAY_DELIVERY
                                ? _c(
                                    "div",
                                    { staticClass: "mb-2" },
                                    [
                                      _c(
                                        "vs-button",
                                        {
                                          attrs: {
                                            size: "small",
                                            type: "gradient"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.liveTracking()
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "text-capitalize" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("action.liveTracking")
                                                )
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("div", [
                                _c("span", { staticClass: "text-capitalize" }, [
                                  _vm._v(_vm._s(_vm.$t("attribute.name")))
                                ]),
                                _vm._v(": "),
                                _c("span", { staticClass: "font-bold" }, [
                                  _vm._v(
                                    _vm._s(_vm.selectedOrderData.driver.name)
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _vm.selectedOrderData.driver.contact_no
                                ? _c("div", [
                                    _c(
                                      "span",
                                      { staticClass: "text-capitalize" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("attribute.phoneNumber")
                                          )
                                        )
                                      ]
                                    ),
                                    _vm._v(":\n            "),
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href:
                                            "tel:" +
                                            _vm.selectedOrderData.driver
                                              .contact_no
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.selectedOrderData.driver
                                              .contact_no
                                          )
                                        )
                                      ]
                                    )
                                  ])
                                : _vm._e()
                            ])
                          : _c("div", [
                              _c("i", [
                                _vm._v(
                                  "--- " +
                                    _vm._s(_vm.$t("dashboard.noDriver")) +
                                    " ---"
                                )
                              ])
                            ]),
                        _vm._v(" "),
                        _c("vs-divider")
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("vx-destination", {
                  staticClass: "mt-3 mb-base",
                  attrs: { data: _vm.renderTimelineData(_vm.selectedOrderData) }
                }),
                _vm._v(" "),
                _c("vs-divider"),
                _vm._v(" "),
                _vm.selectedOrderData.delivery_type !==
                _vm.deliveryTypeEnum.ON_DEMAND_DELIVERY
                  ? _c("div", [
                      _c("small", { staticClass: "activity-desc" }, [
                        _vm._v(_vm._s(_vm.$t("attribute.goodType")))
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _vm.selectedOrderData.dropoff_count < 2
                            ? _c("span", { staticClass: "font-bold" }, [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.selectedOrderData.good_type.name
                                    ) +
                                    "\n          "
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.selectedOrderData.dropoff_count >= 2
                            ? _vm._l(_vm.selectedOrderData.dropoffs, function(
                                dropoff,
                                index
                              ) {
                                return _c(
                                  "span",
                                  {
                                    key: "good_type_dropoff_" + index,
                                    staticClass: "font-bold"
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(dropoff.good_type.name) +
                                        "\n              " +
                                        _vm._s(
                                          index ==
                                            _vm.selectedOrderData
                                              .dropoff_count -
                                              1
                                            ? ""
                                            : "| "
                                        ) +
                                        "\n            "
                                    )
                                  ]
                                )
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("vs-divider")
                        ],
                        2
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.selectedOrderData.packages.length > 0
                  ? _c(
                      "div",
                      [
                        _c("small", { staticClass: "activity-desc" }, [
                          _vm._v(_vm._s(_vm.$t("attribute.package")))
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.selectedOrderData.packages, function(
                          item,
                          index
                        ) {
                          return _c("div", { key: index }, [
                            _c("p", { staticClass: "font-bold text-primary" }, [
                              item.item_desc
                                ? _c("span", [
                                    _vm._v(_vm._s(item.item_desc) + " - ")
                                  ])
                                : _vm._e(),
                              _vm._v(_vm._s(item.qty) + " pcs\n          ")
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                "\n            " +
                                  _vm._s(item.length) +
                                  " cm x " +
                                  _vm._s(item.width) +
                                  " cm x " +
                                  _vm._s(item.height) +
                                  " cm (" +
                                  _vm._s(item.weight) +
                                  "\n            kg)\n          "
                              )
                            ])
                          ])
                        }),
                        _vm._v(" "),
                        _c("vs-divider")
                      ],
                      2
                    )
                  : [
                      _vm.selectedOrderData.good_size
                        ? _c(
                            "div",
                            { staticClass: "w-full" },
                            [
                              "name" in _vm.selectedOrderData.good_size
                                ? _c(
                                    "p",
                                    { staticClass: "font-bold text-primary" },
                                    [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(
                                            _vm.selectedOrderData.good_size.name
                                          ) +
                                          "\n          "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              "desc" in _vm.selectedOrderData.good_size
                                ? _c("p", { staticClass: "activity-desc" }, [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(
                                          _vm.selectedOrderData.good_size.desc
                                        ) +
                                        "\n          "
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c("vs-divider")
                            ],
                            1
                          )
                        : _c(
                            "div",
                            { staticClass: "vx-col w-full text-center" },
                            [
                              _c("i", { staticClass: "text-capitalize" }, [
                                _vm._v(
                                  "--- " +
                                    _vm._s(
                                      _vm.$t(
                                        "shippingDetail.packageNotAvailable"
                                      )
                                    ) +
                                    " ---"
                                )
                              ]),
                              _vm._v(" "),
                              _c("vs-divider")
                            ],
                            1
                          )
                    ],
                _vm._v(" "),
                _vm.selectedOrderData.vehicle_type
                  ? _c(
                      "div",
                      [
                        _c("div", { staticClass: "mb-3" }, [
                          _c("small", { staticClass: "activity-desc" }, [
                            _vm._v(_vm._s(_vm.$t("attribute.vehicle")))
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "vx-row" }, [
                          _c("div", { staticClass: "vx-col" }, [
                            _c("img", {
                              staticStyle: { height: "50px" },
                              attrs: {
                                src:
                                  _vm.selectedOrderData.vehicle_type.icon_path
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "vx-col" }, [
                            _c("div", { staticClass: "font-bold" }, [
                              _vm._v(
                                _vm._s(_vm.selectedOrderData.vehicle_type.name)
                              )
                            ]),
                            _vm._v(" "),
                            _c("small", [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.selectedOrderData.vehicle_type.length
                                  ) +
                                  " cm x " +
                                  _vm._s(
                                    _vm.selectedOrderData.vehicle_type.width
                                  ) +
                                  " cm x\n              " +
                                  _vm._s(
                                    _vm.selectedOrderData.vehicle_type.height
                                  ) +
                                  " cm\n              " +
                                  _vm._s(
                                    _vm.selectedOrderData.vehicle_type.weight
                                      ? ", " +
                                          _vm.selectedOrderData.vehicle_type
                                            .weight +
                                          " kg"
                                      : ""
                                  ) +
                                  "\n            "
                              )
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("vs-divider")
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.selectedOrderData.addons.length > 0
                  ? _c(
                      "div",
                      [
                        _c("div", { staticClass: "mb-3" }, [
                          _c(
                            "small",
                            { staticClass: "font-bold text-uppercase" },
                            [_vm._v(_vm._s(_vm.$t("attribute.addon")))]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "w-full" },
                          _vm._l(_vm.selectedOrderData.addons, function(
                            item,
                            index
                          ) {
                            return _c(
                              "vs-button",
                              {
                                key: "selected_addon_" + index,
                                staticClass: "mr-2 mb-2",
                                attrs: { size: "small" }
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(item.name) +
                                    "\n          "
                                )
                              ]
                            )
                          }),
                          1
                        ),
                        _vm._v(" "),
                        _c("vs-divider")
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "mb-3" }, [
                  _c("small", { staticClass: "activity-desc" }, [
                    _vm._v(_vm._s(_vm.$t("attribute.trackingHistory")))
                  ])
                ]),
                _vm._v(" "),
                "histories" in _vm.selectedOrderData
                  ? _vm._l(_vm.selectedOrderData.histories, function(
                      history,
                      index
                    ) {
                      return _c(
                        "div",
                        { key: index, staticClass: "w-full" },
                        [
                          _c("small", { staticClass: "activity-desc" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.renderToHumanDate(history.created_at)
                                ) +
                                " "
                            )
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "font-bold text-primary" }, [
                            _vm._v(_vm._s(history.status))
                          ]),
                          _vm._v(" "),
                          _c("p", [_vm._v(_vm._s(history.remarks))]),
                          _vm._v(" "),
                          _c("vs-divider")
                        ],
                        1
                      )
                    })
                  : [
                      _c("div", { staticClass: "text-center" }, [
                        _c("i", [
                          _vm._v(
                            " --- " +
                              _vm._s(
                                _vm.$t("general.notAvailable", {
                                  msg: _vm.$t("attribute.trackingHistory")
                                })
                              ) +
                              " --- "
                          )
                        ])
                      ])
                    ]
              ],
              2
            )
      ]),
      _vm._v(" "),
      _c(
        "vs-popup",
        {
          staticStyle: { "z-index": "20000" },
          attrs: {
            "button-close-hidden": "",
            title: _vm.$t("shippingDetail.rateYourOrder"),
            active: _vm.ratingDialogVisibility,
            "prevent-close": ""
          },
          on: {
            "update:active": function($event) {
              _vm.ratingDialogVisibility = $event
            }
          }
        },
        [
          _c("form", [
            _c("div", { staticClass: "vx-row" }, [
              _c(
                "div",
                { staticClass: "vx-col w-full mb-4" },
                [
                  _c("star-rating", {
                    attrs: {
                      "glow-color": "#f48024",
                      glow: 5,
                      "show-rating": false
                    },
                    model: {
                      value: _vm.rate.point,
                      callback: function($$v) {
                        _vm.$set(_vm.rate, "point", $$v)
                      },
                      expression: "rate.point"
                    }
                  }),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.rate.point,
                        expression: "rate.point"
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    attrs: { name: "rating", type: "hidden" },
                    domProps: { value: _vm.rate.point },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.rate, "point", $event.target.value)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "small",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("rating"),
                          expression: "errors.has('rating')"
                        }
                      ],
                      staticClass: "text-danger text-sm"
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("shippingDetail.selectStar")) +
                          "\n          "
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "vx-col w-full mb-2" },
                [
                  _c("vs-input", {
                    staticClass: "w-full",
                    attrs: {
                      name: "Remarks",
                      "icon-no-border": "",
                      icon: "icon icon-package",
                      "icon-pack": "feather",
                      placeholder: _vm.$t("attribute.remark")
                    },
                    model: {
                      value: _vm.rate.note,
                      callback: function($$v) {
                        _vm.$set(_vm.rate, "note", $$v)
                      },
                      expression: "rate.note"
                    }
                  })
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "vx-col w-full mb-2" },
            [
              _c(
                "vs-button",
                {
                  staticClass: "mr-2 mt-5 float-right",
                  attrs: { type: "filled" },
                  on: {
                    click: function($event) {
                      return _vm.onClickSubmitRate()
                    }
                  }
                },
                [
                  _c("span", { staticClass: "text-uppercase" }, [
                    _vm._v(_vm._s(_vm.$t("action.rate")))
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "vs-button",
                {
                  staticClass: "mr-2 mt-5 float-right",
                  attrs: { type: "flat" },
                  on: {
                    click: function($event) {
                      _vm.ratingDialogVisibility = false
                    }
                  }
                },
                [
                  _c("span", { staticClass: "text-uppercase" }, [
                    _vm._v(_vm._s(_vm.$t("action.close")))
                  ])
                ]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "vs-popup",
        {
          staticStyle: { "z-index": "20000" },
          attrs: {
            "button-close-hidden": "",
            title: _vm.$t("shippingDetail.selectPaperSize"),
            active: _vm.paperSizeDialogVisibility,
            "prevent-close": ""
          },
          on: {
            "update:active": function($event) {
              _vm.paperSizeDialogVisibility = $event
            }
          }
        },
        [
          _c("div", { staticClass: "vx-col w-full" }, [
            _c(
              "div",
              { staticClass: "vx-row w-full" },
              _vm._l(_vm.waybillPaperSizes, function(size, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "vx-col sm:w-1/3 md:w-1/5 mb-2" },
                  [
                    _c(
                      "vs-button",
                      {
                        staticClass:
                          "text-capitalize font-bold w-full p-3 pr-5 pl-5",
                        attrs: { type: "filled" },
                        on: {
                          click: function($event) {
                            return _vm.onClickPrintWaybill(size)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(size.toUpperCase()) +
                            "\n          "
                        )
                      ]
                    )
                  ],
                  1
                )
              }),
              0
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "vs-popup",
        {
          staticStyle: { "z-index": "20000" },
          attrs: {
            "button-close-hidden": "",
            title: _vm.$t("shippingDetail.enrouteOrder"),
            active: _vm.enrouteOrderDialogVisibility,
            "prevent-close": ""
          },
          on: {
            "update:active": function($event) {
              _vm.enrouteOrderDialogVisibility = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "vx-col w-full" },
            [
              _c("div", { staticClass: "text-md" }, [
                _vm._v(
                  _vm._s(_vm.$t("shippingDetail.enrouteConfirmation")) + "."
                )
              ]),
              _vm._v(" "),
              _c("vs-divider"),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "flex justify-between flex-wrap" },
                [
                  _c(
                    "vs-button",
                    {
                      attrs: { type: "border", color: "primary" },
                      on: {
                        click: function($event) {
                          _vm.enrouteOrderDialogVisibility = false
                        }
                      }
                    },
                    [
                      _c("span", { staticClass: "text-uppercase" }, [
                        _vm._v(_vm._s(_vm.$t("action.close")))
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "vs-button",
                    {
                      attrs: { type: "filled", color: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.enrouteOrder()
                        }
                      }
                    },
                    [
                      _c("span", { staticClass: "text-uppercase" }, [
                        _vm._v(_vm._s(_vm.$t("action.enroute")))
                      ])
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "vx-col" },
                _vm._l(_vm.enrouteErrors, function(error) {
                  return _c(
                    "div",
                    { key: error.message, staticClass: "mb-2" },
                    [
                      _c(
                        "vs-alert",
                        { attrs: { color: "danger", icon: "new_releases" } },
                        [_c("span", [_vm._v(_vm._s(error))])]
                      )
                    ],
                    1
                  )
                }),
                0
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _vm.selectedOrderData
        ? _c(
            "vs-popup",
            {
              key: _vm.cancelOrderDialogKey,
              staticStyle: { "z-index": "20000" },
              attrs: {
                "button-close-hidden": "",
                title: _vm.$t("shippingDetail.cancelOrder"),
                active: _vm.cancelOrderDialogVisibility,
                "prevent-close": ""
              },
              on: {
                "update:active": function($event) {
                  _vm.cancelOrderDialogVisibility = $event
                }
              }
            },
            [
              _c(
                "div",
                { staticClass: "vx-col" },
                _vm._l(_vm.cancelErrors, function(error) {
                  return _c(
                    "div",
                    { key: error.message, staticClass: "mb-2" },
                    [
                      _c(
                        "vs-alert",
                        { attrs: { color: "danger", icon: "new_releases" } },
                        [_c("span", [_vm._v(_vm._s(error))])]
                      )
                    ],
                    1
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "vx-col w-full" },
                [
                  _c("div", {
                    staticClass: "vx-col text-md",
                    domProps: { innerHTML: _vm._s(_vm.cancellable.text) }
                  }),
                  _vm._v(" "),
                  _vm.selectedOrderData &&
                  _vm.selectedOrderData.delivery_type ==
                    _vm.deliveryTypeEnum.ONE_TO_THREE_DAYS_DELIVERY
                    ? _c("vs-divider", [
                        _c(
                          "span",
                          {
                            staticClass: "cursor-pointer",
                            on: {
                              click: function($event) {
                                return _vm.onClickPrintWaybill("a5")
                              }
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("shippingDetail.viewRemainingOrder")
                              )
                            )
                          ]
                        )
                      ])
                    : _c("vs-divider"),
                  _vm._v(" "),
                  _c("div", { staticClass: "vx-col" }, [
                    _c(
                      "div",
                      { staticClass: "flex justify-between flex-wrap" },
                      [
                        _c(
                          "vs-button",
                          {
                            attrs: { type: "border", color: "primary" },
                            on: {
                              click: function($event) {
                                _vm.cancelOrderDialogVisibility = false
                              }
                            }
                          },
                          [
                            _c("span", { staticClass: "text-capitalize" }, [
                              _vm._v(_vm._s(_vm.$t("action.close")))
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "vx-row" },
                          [
                            _c(
                              "vs-button",
                              {
                                staticClass: "float-right ml-2",
                                attrs: { type: "filled", color: "primary" },
                                on: {
                                  click: function($event) {
                                    return _vm.acceptCancelOrder({
                                      cancel_bulk: false
                                    })
                                  }
                                }
                              },
                              [
                                _c("span", { staticClass: "text-capitalize" }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("shippingDetail.cancelOrder"))
                                  )
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _vm.cancellable.cancellable_orders > 1
                              ? _c(
                                  "vs-button",
                                  {
                                    staticClass: "float-right ml-2",
                                    attrs: {
                                      type: "gradient",
                                      color: "primary"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.acceptCancelOrder({
                                          cancel_bulk: true
                                        })
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "text-capitalize" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$tc(
                                              "shippingDetail.cancelOrderAction",
                                              2,
                                              {
                                                count:
                                                  _vm.cancellable
                                                    .cancellable_orders
                                              }
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "vx-col" },
                    _vm._l(_vm.apiErrors, function(error) {
                      return _c(
                        "div",
                        { key: error.message, staticClass: "mb-2" },
                        [
                          _c(
                            "vs-alert",
                            {
                              attrs: { color: "danger", icon: "new_releases" }
                            },
                            [_c("span", [_vm._v(_vm._s(error))])]
                          )
                        ],
                        1
                      )
                    }),
                    0
                  )
                ],
                1
              )
            ]
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }